import React, { useState, useEffect } from "react";
import { Col, Row, Button, Table, Input, Form } from "antd";
import { EditOutlined, DeleteOutlined, ReloadOutlined } from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";

import Update from "../../../components/dashboard/user/Update";
import Create from "../../../components/dashboard/user/Create";
import Import from "../../../components/dashboard/user/Import";
import Delete from "../../../components/dashboard/user/Delete";
import DrawerExportTable from "../../../components/dashboard/Export/DrawerExportTable";
import endpoints from "../../../services/endpoints";

import "../../../assets/styles/admin.css";
import "./Suggestions.css";

const DashboardSuggestions = () => {
  const [data, setData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isOpenExportDrawer, setIsOpenExportDrawer] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const columns = [
    {
      title: "Nome",
      dataIndex: "name",
    },
    {
      title: "E-mail",
      dataIndex: "email",
    },
    {
      title: "Assunto",
      dataIndex: "subject",
    },
    {
      title: "Texto",
      dataIndex: "text",
    },
    {
      title: "",
      dataIndex: "actions",
    },
  ];

  useEffect(() => {
    handleGetData();
  }, []);

  function handleGetData() {
    setIsLoading(true);
    axios
      .get(endpoints.suggestions.read)
      .then((res) => {
        setData(res.data);
        handlePrepareData(res.data);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  }

  function handlePrepareData(data) {
    setIsLoading(true);
    let aux = [];
    for (let i = 0; i < data.length; i++) {
      let auxObj = {
        id: data[i].id,
        name: data[i].name,
        email: data[i].email,
        subject: data[i].subject,
        text: data[i].text,
        created_at: dayjs(data[i].created_at).format("DD-MM-YYYY"),
        actions: (
          <Button onClick={() => handleOpenDelete(data[i])}>
            <DeleteOutlined />
          </Button>
        ),
        full_data: data[i],
      };

      aux.push(auxObj);
    }

    setIsLoading(false);
    setTableData(aux);
  }

  function handleOpenDelete(data) {
    setSelectedData(data);
    setIsOpenDelete(true);
  }

  function handleCloseDelete() {
    setSelectedData({});
    setIsOpenDelete(false);
    handleGetData();
  }

  function handleSearch(e) {
    let searchString = e.search;
    let filterData = data.filter((item) => item.email.includes(searchString) || item.name.toLowerCase().includes(searchString));
    handlePrepareData(filterData);
  }

  function handleOpenExport() {
    setIsOpenExportDrawer(true);
  }

  function handleCloseExport() {
    setIsOpenExportDrawer(false);
  }

  return (
    <Row>
      <Delete open={isOpenDelete} close={handleCloseDelete} data={selectedData} />
      <DrawerExportTable open={isOpenExportDrawer} close={handleCloseExport} data={tableData} />
      <Col span={24}>
        <Row className="title-admin-page d-flex jc-sb ai-center">
          <Col span={6}>
            <h2 className="m-0">Sugestões</h2>
          </Col>
          <Col span={18}>
            <div className="d-flex jc-end ai-center">
              <Form onValuesChange={handleSearch} style={{ maxWidth: 400, borderRadius: 0 }}>
                <Form.Item name="search" className="mb-0 mr-10">
                  <Input size="large" className="" style={{ maxWidth: 400, borderRadius: 0 }} placeholder="Procurar..." />
                </Form.Item>
              </Form>
              <Button className="mr-10" size="large" onClick={handleGetData}>
                <ReloadOutlined />
              </Button>
              <Button className="mr-10" size="large" onClick={handleOpenExport}>
                Exportar
              </Button>
            </div>
          </Col>
        </Row>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Table loading={isLoading} columns={columns} dataSource={tableData} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default DashboardSuggestions;
